<template>
    <NuxtImg
        :provider="provider"
        :src="computedSrc"
        :alt="alt"
        :width="width"
        :height="height"
        :sizes="sizes"
        :quality="computedQuality"
        :loading="loading"
        :preload="preloadWithHighPriority ? {fetchPriority: 'high'} : undefined"
        densities="x1 x2"
    />
</template>

<script setup lang="ts">
    import {computed, getCurrentInstance} from 'vue';
    import {useLogger} from '#imports';
    import type {MaltImgProps} from '../types/malt-img';

    const props = withDefaults(defineProps<MaltImgProps>(), {
        provider: 'filerobot',
    });

    const logger = useLogger();

    if (process.env.NODE_ENV === 'development' && !props.sizes && !props.width && !props.height) {
        const source = getCurrentInstance()?.parent?.type.__file;
        logger.error(`[MaltImg] <width> or <height> or <sizes> is required. Please check usage in ${source}`);
    }

    const regex = /\/\/dam\.malt\.com(.+)$/;

    const computedSrc = computed(() => {
        if (!props.src) {
            logger.warn('[MaltImg] <src> should not be falsy');
            return '';
        }
        const match = props.src.match(regex);
        if (match && match[1]) {
            return match[1];
        }
        return props.src;
    });

    const computedQuality = computed(() => {
        if (props.quality) {
            return props.quality;
        } else if (!props.width && !props.height) {
            return 80;
        }
        return undefined;
    });

    const preloadWithHighPriority = computed((): boolean => {
        return props.loading === 'eager';
    });
</script>
